import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './initialState'

const geolocationBranchOfficesSlice = createSlice({
  name: 'geolocationBranchOffices',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const geolocationBranchOfficesActions =
  geolocationBranchOfficesSlice.actions
export const { reducer: geolocationBranchOfficesReducer } =
  geolocationBranchOfficesSlice
